import { facilita } from '@/global'
import { storage } from '@/services/storage'

/**
 * Recebe uma string base e a função do assinante e retorna as keywords/marcadores
 * deste
 *
 * @param {String} base String base para as keywords
 * @param {String} role Função do assinante
 * @returns 
 */
export const $mx_generateSignerKeyword = (base, role) => {
    // Pega apenas a string entre barras, caso exista
    const pattern = /\/(.*?)\//g
    const rawBase = /\/.*?\//.test(base)
        ? pattern.exec(base)[1]
        : base
    let keyword = {
        name: rawBase ? `/${rawBase}/` : ''
    }

    switch (role) {
        case 'witness':
            keyword['approve'] = `/${rawBase}_approve/`
            break
    
        case 'signers':
            keyword['sign'] = `/${rawBase}_sign/`
            break
    }

    return keyword
}

export const isJSON = (string) => {
    try {
        JSON.parse(string)

    } catch (e) {
        return false
    }

    return true
}

export default {
    data() {
        return{
            cont: 0
        }
    },
    methods: {

        $mx_validateCPF(cpf){
            return this.validateCpf(cpf)
        },

        $mx_validateCNPJ(cnpj){
            return this.validateCnpj(cnpj)
        },

        $mx_validateEmail(email){
            if(email){
                // eslint-disable-next-line no-useless-escape
                const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
                return email.match(re)
            } else return false
        },

        // $mx_validatePhone(phone){
        //     if(phone){
        //         // eslint-disable-next-line no-useless-escape
        //         const re = /(\(?\d{2}\)?\s)?(\d{4,5}\-\d{4})/
        //         return phone.match(re)
        //     } else return false
        // },

        $mx_validatePhone(phone, field, required){
            const countryCodes = {
                "1": "+# (###) ###-####",
                "7": "+# (###) ###-##-##",
                "20": "+## (###) ###-####",
                "27": "+## ##-###-####",
                "30": "+## (###) ###-####",
                "31": "+## ##-###-####",
                "32": "+## (###) ###-###",
                "33": "+## (###) ###-###",
                "34": "+## (###) ###-###",
                "36": "+## (###) ###-###",
                "39": "+## (###) ####-###",
                "40": "+## ##-###-####",
                "41": "+## ##-###-####",
                "43": "+## (###) ###-####",
                "44": "+## ##-####-####",
                "45": "+## ##-##-##-##",
                "46": "+## ##-###-####",
                "47": "+## (###) ##-###",
                "48": "+## (###) ###-###",
                "49": "+## (####) ###-####",
                "51": "+## (###) ###-###",
                "52": "+## ##-##-####",
                "53": "+## #-###-####",
                "54": "+## (###) ###-####",
                "55": "+## (##) #####-####",
                "56": "+## #-####-####",
                "57": "+## (###) ###-####",
                "58": "+## (###) ###-####",
                "60": "+## #-####-####",
                "61": "+## #-####-####",
                "62": "+## (###) ###-##-###",
                "63": "+## (###) ###-####",
                "64": "+## #-###-###",
                "65": "+## ####-####",
                "66": "+## ##-###-###",
                "77": "+## (###) ###-##-##",
                "81": "+## (###) ###-###",
                "82": "+## ##-###-####",
                "84": "+## ##-####-###",
                "86": "+## (###) ####-###",
                "90": "+## (###) ###-####",
                "91": "+## (####) ###-###",
                "92": "+## (###) ###-####",
                "93": "+## ##-###-####",
                "94": "+## ##-###-####",
                "95": "+## ###-###",
                "98": "+## (###) ###-####",
                "211": "+### ##-###-####",
                "212": "+### ##-####-###",
                "213": "+### ##-###-####",
                "216": "+### ##-###-###",
                "218": "+### ##-###-###",
                "220": "+### (###) ##-##",
                "221": "+### ##-###-####",
                "222": "+### ##-##-####",
                "223": "+### ##-##-####",
                "224": "+### ##-###-###",
                "225": "+### ##-###-###",
                "226": "+### ##-##-####",
                "227": "+### ##-##-####",
                "228": "+### ##-###-###",
                "229": "+### ##-##-####",
                "230": "+### ###-####",
                "231": "+### ##-###-###",
                "232": "+### ##-######",
                "233": "+### (###) ###-###",
                "234": "+### ##-###-##",
                "235": "+### ##-##-##-##",
                "236": "+### ##-##-####",
                "237": "+### ####-####",
                "238": "+### (###)##-##",
                "239": "+### ##-#####",
                "240": "+### ##-###-####",
                "241": "+### #-##-##-##",
                "242": "+### ##-#####",
                "243": "+### (###) ###-###",
                "244": "+### (###) ###-###",
                "245": "+### #-######",
                "246": "+### ###-####",
                "247": "+### ####",
                "248": "+### #-###-###",
                "249": "+### ##-###-####",
                "250": "+### (###) ###-###",
                "251": "+### ##-###-####",
                "252": "+### #-###-###",
                "253": "+### ##-##-##-##",
                "254": "+### ###-######",
                "255": "+### ##-###-####",
                "256": "+### (###) ###-###",
                "257": "+### ##-##-####",
                "258": "+### ##-###-###",
                "260": "+### ##-###-####",
                "261": "+### ##-##-#####",
                "262": "+### #####-####",
                "263": "+### #-######",
                "264": "+### ##-###-####",
                "265": "+### #-###-###",
                "266": "+### #-###-####",
                "267": "+### ##-###-###",
                "268": "+### ##-##-####",
                "269": "+### ##-#####",
                "290": "+### ####",
                "291": "+### #-###-###",
                "297": "+### ###-####",
                "298": "+### ###-###",
                "299": "+### ##-##-##",
                "350": "+### ###-#####",
                "351": "+### ##-###-####",
                "352": "+### (###) ###-###",
                "353": "+### (###) ###-###",
                "354": "+### ###-####",
                "355": "+### (###) ###-###",
                "356": "+### ####-####",
                "357": "+### ##-###-###",
                "358": "+### (###) ###-##-##",
                "359": "+### (###) ###-###",
                "370": "+### (###) ##-###",
                "371": "+### ##-###-###",
                "372": "+### ####-####",
                "373": "+### ####-####",
                "374": "+### ##-###-###",
                "375": "+### (##) ###-##-##",
                "376": "+### ###-###",
                "377": "+### ##-###-###",
                "378": "+### ####-######",
                "380": "+### (##) ###-##-##",
                "381": "+### ##-###-####",
                "382": "+### ##-###-###",
                "383": "+### ###-###-###",
                "385": "+### ##-###-###",
                "386": "+### ##-###-###",
                "387": "+### ##-####",
                "389": "+### ##-###-###",
                "420": "+### (###) ###-###",
                "421": "+### (###) ###-###",
                "423": "+### (###) ###-####",
                "500": "+### #####",
                "501": "+### ###-####",
                "502": "+### #-###-####",
                "503": "+### ##-##-####",
                "504": "+### ####-####",
                "505": "+### ####-####",
                "506": "+### ####-####",
                "507": "+### ###-####",
                "508": "+### ##-####",
                "509": "+### ##-##-####",
                "590": "+### (###) ###-###",
                "591": "+### #-###-####",
                "592": "+### ###-####",
                "593": "+### ##-###-####",
                "594": "+### #####-####",
                "595": "+### (###) ###-###",
                "596": "+### (###) ##-##-##",
                "597": "+### ###-###",
                "598": "+### #-###-##-##",
                "670": "+### ###-####",
                "672": "+### ###-###",
                "673": "+### ###-####",
                "674": "+### ###-####",
                "675": "+### (###) ##-###",
                "676": "+### #####",
                "677": "+### #####",
                "678": "+### #####",
                "679": "+### ##-#####",
                "680": "+### ###-####",
                "681": "+### ##-####",
                "682": "+### ##-###",
                "683": "+### ####",
                "685": "+### ##-####",
                "686": "+### ##-###",
                "687": "+### ##-####",
                "688": "+### #####",
                "689": "+### ##-##-##",
                "690": "+### ####",
                "691": "+### ###-####",
                "692": "+### ###-####",
                "850": "+### ###-####-###",
                "852": "+### ####-####",
                "853": "+### ####-####",
                "855": "+### ##-###-###",
                "856": "+### ##-###-###",
                "870": "+### ###-###-###",
                "880": "+### ####-######",
                "886": "+### ####-####",
                "960": "+### ###-####",
                "961": "+### ##-###-###",
                "962": "+### #-####-####",
                "963": "+### ##-####-###",
                "964": "+### (###) ###-####",
                "965": "+### ####-####",
                "966": "+### #-###-####",
                "967": "+### #-###-###",
                "968": "+### ##-###-###",
                "970": "+### ##-###-####",
                "971": "+### #-###-####",
                "972": "+### ##-###-####",
                "973": "+### ####-####",
                "974": "+### ####-####",
                "975": "+### ##-###-###",
                "976": "+### ##-##-####",
                "977": "+### ##-###-###",
                "992": "+### ##-###-####",
                "993": "+### #-###-####",
                "994": "+### ##-###-##-##",
                "995": "+### (###) ###-###",
                "996": "+### (###) ###-###",
                "998": "+### ##-###-####"
            }

            if (!phone) return false


            if(this.cont < 7 ) this.cont++
            if(required != true && phone == '+55' && this.cont >= 7){
                return true
            }

            // Regex para validar números de telefone internacionais
            const regex = /(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/
            
            // Sanitizar o número de telefone
            const phoneSanitized = phone.replace(/\D/g, '')
            const match = phoneSanitized.match(regex)
        
            if (!match) return false
        
            const countryCode = match[1]
            const mask = countryCodes[countryCode]
            
            if (!mask) return false
        
            const countMask = mask.split('#').length - 1
            const digits = phoneSanitized.match(/\d/g).length
        
            if (countryCode === '55') {
                const brazilianNumberRegex = field === 'mobile' ? /^55\d{2}\d{5}\d{4}$/ : /^55\d{2}\d{4}\d{4}$/
            
                return brazilianNumberRegex.test(phoneSanitized)
            }
        
            // A validação é válida se a mascara for completa pelos digitos
            return countMask === digits
        },

        $mx_oldPanelLink(link){
            return this.oldPanelLink(link)
        },

        $mx_oldPanelLinkButton(link){
            return this.oldPanelLinkButton(link)
        },

        oldPanelLink(link) {
            return facilita.panel + link
        },
        oldPanelLinkButton(link) {
            window.location.pathname = link
        },
        setStatusColor(status) {
            switch (status) {
                case 'reserved':
                    return '#f1c40f'
                case 'sold':
                    return '#3CA569'
                case 'canceled':
                    return '#F53B57'
                default:
                    return '#0073C8'
            }
        },
        //remove acentos
        removeAccentToLowerCase(text)
        {    
            function regex(value, returnValue) {
                return new RegExp(value, returnValue)
            }
            text = text.toLowerCase();                                                         
            text = text.replace(regex('[ÁÀÂÃ]','gi'), 'a');
            text = text.replace(regex('[ÉÈÊ]','gi'), 'e');
            text = text.replace(regex('[ÍÌÎ]','gi'), 'i');
            text = text.replace(regex('[ÓÒÔÕ]','gi'), 'o');
            text = text.replace(regex('[ÚÙÛ]','gi'), 'u');
            text = text.replace(regex('[Ç]','gi'), 'c');
            return text;                 
        },
        // remove char especial
        removeCharMask(str) {
            let text = this.removeAccentToLowerCase(str)
            return text.replace(/[^\w\s]/gi, '').trim()
        },
        setStatusBgColor(status) {
            switch (status) {
                case 'reserved':
                    return 'backgroundColor: #f1c40f'
                case 'sold':
                    return 'backgroundColor: #3CA569'
                case 'canceled':
                    return 'backgroundColor: #F53B57'
                default:
                    return 'backgroundColor: #0073C8'
            }
        },
        stripTags(textHtml) {
            return textHtml.replace(/(<([^>]+)>)/ig, "")
        },
        resume(textHtml, textLength = 100) {
            return textHtml.substring(0, textLength).replace(/(<([^>]+)>)/ig, "") + '...'
        },
        setIcon(type) {
            switch (type) {
                case 'mail':
                    return '<i class="far fa-envelope-open"></i>'
                case 'call':
                    return '<i class="far fa-phone-alt"></i>'
                case 'whatsapp':
                    return '<i class="fab fa-whatsapp"></i>'
                case 'visit':
                    return '<i class="far fa-calendar-alt"></i>'
                case 'observation':
                    return '<i class="far fa-comment-alt-lines"></i>'
                case 'chat':
                    return '<i class="far fa-comments-alt"></i>'
                default:
                    return '<i class="far fa-cog"></i>'
            }
        },
        getImgCDN(url){
            let cdn = process.env.VUE_APP_CDN
            if(url && url.indexOf("_uploads/companies/") != 0){
                /**
                *se não existir _uplpads/companies/ retorna a imagem alterada como base64
                 */
                return url
            } else {
                /**
                *se existir imagem salva retorna a image caso não exista retornará a imagem no-avatar
                 */
                return url ? cdn + url : require('@/assets/imgs/no-avatar.png')
            }
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        $mx_numberFormat(number) {
            return (number || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        validateCpf(cpf) {
            let sum = 0
            let rest
            let nonValid = [
                "00000000000",
                "11111111111",
                "22222222222",
                "33333333333",
                "44444444444",
                "55555555555",
                "66666666666",
                "77777777777",
                "88888888888",
                "99999999999"
            ]
            cpf = cpf.replace(/\D+/g, "")

            if (nonValid.includes(cpf)) return false

            for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
            rest = (sum * 10) % 11;

            if ((rest == 10) || (rest == 11)) rest = 0
            if (rest != parseInt(cpf.substring(9, 10))) return false

            sum = 0
            for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
            rest = (sum * 10) % 11

            if ((rest == 10) || (rest == 11)) rest = 0
            if (rest != parseInt(cpf.substring(10, 11))) return false
            return true
        },
        validateCnpj(cnpj) {
            cnpj = cnpj.replace(/[^\d]+/g, '')
            if (cnpj == '') return false

            if (cnpj.length < 14)
                return null

            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" ||
                cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999")
                return false

            // Valida DVs
            let lengths = cnpj.length - 2
            let numercs = cnpj.substring(0, lengths);
            let digits = cnpj.substring(lengths)
            let sums = 0
            let pos = lengths - 7
            for (var i = lengths; i >= 1; i--) {
                sums += numercs.charAt(lengths - i) * pos--
                    if (pos < 2)
                        pos = 9
            }
            let results = sums % 11 < 2 ? 0 : 11 - sums % 11
            if (results != digits.charAt(0))
                return false

            lengths = lengths + 1
            numercs = cnpj.substring(0, lengths)
            sums = 0
            pos = lengths - 7
            for (i = lengths; i >= 1; i--) {
                sums += numercs.charAt(lengths - i) * pos--
                    if (pos < 2)
                        pos = 9
            }
            results = sums % 11 < 2 ? 0 : 11 - sums % 11
            if (results != digits.charAt(1))
                return false

            return true

        },
        isJSON,
        parseJwt(token) {
            var base64Url = token.split('.')[1]
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            }).join(''))

            return JSON.parse(jsonPayload)
        },
        formatMoney(number, decPlaces, decSep, thouSep) {
            decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces
            decSep = typeof decSep === "undefined" ? "," : decSep
            thouSep = typeof thouSep === "undefined" ? "." : thouSep
            var sign = number < 0 ? "-" : ""
            var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
            var j = (j = i.length) > 3 ? j % 3 : 0

            return sign +
                (j ? i.substr(0, j) + thouSep : "") +
                i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
                (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "")
        },
        /**
         * Cria um segundo objeto a partir de um primeiro com as propriedades indicadas em
         * um array
         * 
         * @param {Object} object 
         * @param {Array} properties 
         */
        getPropertiesFromObject(object, properties) {
            let newObj = {}
            for (const prop of properties) {
                newObj[prop] = object[prop]
            }

            return newObj
        },
        //deixa a primeira palavra em maiuscula
        capitalizeFirstLetter(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },

        getInstance(val) {
            let api_config = storage.get('api_config');
            api_config = JSON.parse(api_config)

            return api_config && api_config.instance ? 
            val ? this.capitalizeFirstLetter(api_config.instance) 
            : api_config.instance : ''
        },

        getUrl(url) {
            let data = window.location.href
            let href = data.split('/')
            data = href[0] + '//' + href[2] + (process.env.NODE_ENV === 'development' ? '/v2-dev/' : '/v2/') + url
            return data
        },
        getUrlLegacy(url) {
            let data = window.location.href
            let href = data.split('/')
            data = href[0] + '//' + href[2] + url
            return data
        },
        /**
         * @param {String} s 
         * @returns String sem caracteres especiais
         */
        stringNormalize(s) {
            return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        },
        /**
         * @param {String} s 
         * @returns String sem caracteres especiais em formato de Snake Case snake_case
         */
        snakeCase(s) {
            return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/\W+/g, ' ')
            .split(/ |\B(?=[A-Z])/)
            .map(word => word.toLowerCase())
            .join('_')
        },

        getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },

        sortObject(arrayTransform, attrTransform) {
            return arrayTransform.sort(function (a, b) {
				return a[attrTransform] - b[attrTransform]
			})
        },
        $mx_generateSignerKeyword
    }
}